import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay]);

Swiper.use([Navigation]);

const swiperP = new Swiper('.portfolio__swiper', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      loop: true,
      autoplay: {
        delay: 3000,
      },
});

const swiperR = new Swiper('.reviews__swiper', {
  slidesPerView: 'auto',
  spaceBetween: 20,
});

const swiperBH = new Swiper('.blog-hero__swiper', {
  slidesPerView: 1,
});

